import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';

import { AzureAuthService } from 'src/service/azure-auth.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingGuard implements CanActivate {
  constructor(
    private azureAuthService: AzureAuthService,
    private router: Router
  ) {}
  
  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this.azureAuthService.isAuthenticated()){
      const userProfile = await this.azureAuthService.userProfileCreateReturn();
      
      if (!userProfile.acceptedTerms && next.routeConfig.path !== "onboarding") {
        // redirect user not yet onboarded to onboarding page if they attempt to navigate elsewhere.
        this.router.navigate(['/onboarding']);
        return false;
      }

      /*var uri = this.getCookieValue("redirect_uri");
      if (uri) {
        document.cookie = "redirect_uri=;";
        this.router.navigateByUrl(uri);  
        return false;
      }*/

      if (userProfile.acceptedTerms && next.routeConfig.path === "onboarding") {
        if (!state.root.routeConfig) {
          // If the first page the user loads is onboarding, redirect to home.
          this.router.navigate(['/home']);
        }
        return false;
      }

      return true;
    }
    return true;
  }

  getCookieValue(name) {
    const nameString = name + "="  
    const value = document.cookie.split(";").filter(item => {
      return item.includes(nameString);
    })
  
    if (value.length) {
      return value[0].substring(nameString.length+1, value[0].length);
    } else {
      return "";
    }
  }

}